import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import { submit, reset, isSubmitting, touch, isValid, hasSubmitSucceeded, formValueSelector } from 'redux-form';

import Button from 'components/common/Button';
import Typography from '@material-ui/core/Typography';

import SignUpForm from './SignUpForm';

const styles = theme => ({
  root: {
    display: 'flex',
    width: '100%',
    minHeight: 434,
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      width: 556,
    },
  },
  form: {
    padding: '0 16px 16px',
    overflow: 'hidden',
    [theme.breakpoints.up('sm')]: {
      padding: '0 113px 24px',
    },
  },
  grid: {
    display: 'flex',
  },
  footer: {
    padding: '8px 16px',
    borderTop: `1px solid ${theme.palette.primary.A100}`,
    [theme.breakpoints.up('sm')]: {
      padding: '8px 63px',
    },
    '& $grid': {
      justifyContent: 'space-between',
    },
  },
});

const SignUp = ({
  form, actions, submitting, submitSucceeded, onSubmitSuccess, passwordValue, classes,
}) => (
  <Paper
    className={classes.root}
    square
    elevation={5}
  >
    <SignUpForm
      className={classes.form}
      form={form}
      onSubmitSuccess={onSubmitSuccess}
      passwordValue={passwordValue}
    />
    {!submitSucceeded &&
      <div className={classes.footer}>
        <Grid
          className={classes.grid}
          container
          justify="space-between"
          alignItems="center"
          spacing={16}
        >
          <Grid item>
            <Typography variant="caption">
              STEP 1/4
            </Typography>
          </Grid>
          <Grid item>
            <Grid
              className={classes.grid}
              container
              justify="space-between"
              alignItems="center"
              spacing={16}
            >
              <Grid item>
                <Button
                  className={classes.button}
                  onClick={() => {
                    actions.reset(form);
                  }}
                  variant="raised"
                  disabled={submitting}
                  size="lg"
                >
                  Clear
                </Button>
              </Grid>
              <Grid item>
                <Button
                  className={classes.button}
                  onClick={() => {
                    actions.submit(form);
                  }}
                  variant="raised"
                  color="primary"
                  disabled={submitting}
                  size="lg"
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    }
  </Paper>
);

SignUp.propTypes = {
  form: PropTypes.string,
  passwordValue: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
  submitSucceeded: PropTypes.bool.isRequired,
  onSubmitSuccess: PropTypes.func,
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
    touch: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    form: PropTypes.string.isRequired,
    footer: PropTypes.string.isRequired,
  }).isRequired,
};

SignUp.defaultProps = {
  form: 'signUpForm',
  onSubmitSuccess: () => {},
  passwordValue: null,
};

const mapStateToProps = (store, ownProps) => {
  const selector = formValueSelector(ownProps.form);
  return {
    submitting: isSubmitting(ownProps.form)(store),
    submitSucceeded: hasSubmitSucceeded(ownProps.form)(store),
    valid: isValid(ownProps.form)(store),
    passwordValue: selector(store, 'Password'),
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit, reset, touch }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(SignUp),
);



// WEBPACK FOOTER //
// ./src/components/account/SignUp/SignUp.js